export default "__VITE_ASSET__CCXGSJHh__"